// BMP-HOOK-START:find-my-size
// "Find my size" under the Size buttons (markup: snippets/bmp-find-my-size.liquid).
// Delegated and loaded once: Horizon morphs the buy box on every size/color change, which resets the
// server markup, so open/height/weight live here per product and are re-applied after each morph.
(() => {
  if (window.__bmpFindMySize) return;
  window.__bmpFindMySize = true;

  const ORDER = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL'];
  // Gildan 64000 body chest max per size (in), shirt width across (in), chest range for the copy.
  const BANDS = [['XS', 33], ['S', 37], ['M', 41], ['L', 45], ['XL', 49], ['2XL', 53], ['3XL', 57], ['4XL', 61], ['5XL', 65]];
  const FLAT = { XS: 16, S: 18, M: 20, L: 22, XL: 24, '2XL': 26, '3XL': 28, '4XL': 30, '5XL': 32 };
  const RANGE = { XS: '30–33', S: '34–37', M: '38–41', L: '42–45', XL: '46–49', '2XL': '50–53', '3XL': '54–57', '4XL': '58–61', '5XL': '62–65' };
  const est = (hIn, lb) => 21 + 0.115 * lb - 0.2 * (hIn - 70);
  const recommend = (hIn, lb) => { const c = est(hIn, lb); for (const [z, mx] of BANDS) if (c <= mx) return z; return '5XL'; };
  window.__bmpFmsRecommend = recommend;

  const state = new Map(); // productId -> { open, h, w }
  const st = (el) => {
    const id = el.dataset.productId;
    if (!state.has(id)) state.set(id, { open: false, h: null, w: null });
    return state.get(id);
  };
  const up = (s) => String(s || '').trim().toUpperCase();

  // The snippet renders right after <variant-picker> (outside it), so find the nearest picker upwards.
  function scope(el) {
    for (let n = el.parentElement; n; n = n.parentElement) {
      const v = n.querySelector('variant-picker');
      if (v) return v;
    }
    return document;
  }
  function sizeInputs(el) {
    const name = el.dataset.sizeName || 'Size';
    return [...scope(el).querySelectorAll('input[type="radio"]')].filter((i) => i.dataset.optionName === name);
  }
  function selectedColor(el) {
    const name = el.dataset.colorName;
    if (!name) return '';
    const s = scope(el);
    const r = [...s.querySelectorAll('input[type="radio"]:checked')].find((i) => i.dataset.optionName === name);
    if (r) return r.value;
    const sel = [...s.querySelectorAll('select')].find((x) => x.name && x.name.startsWith(name));
    return sel ? sel.value : '';
  }
  function variants(el) {
    try { return JSON.parse(el.querySelector('[data-bmp-fms-variants]').textContent); } catch { return []; }
  }
  function availableSizes(el, color) {
    return variants(el).filter((v) => v[2] && (!color || v[0] === color)).map((v) => up(v[1]));
  }
  function closest(target, avail) {
    if (avail.includes(target)) return target;
    const t = ORDER.indexOf(target);
    let best = null, bestScore = Infinity;
    for (const z of avail) {
      const i = ORDER.indexOf(z);
      if (i < 0) continue;
      const score = Math.abs(i - t) * 100 - i; // nearest, tie -> larger
      if (score < bestScore) { bestScore = score; best = z; }
    }
    return best;
  }

  function setText(nodes, text) { nodes.forEach((n) => { if (n.textContent !== text) n.textContent = text; }); }

  function render(el) {
    const s = st(el);
    const panel = el.querySelector('[data-bmp-fms-panel]');
    const hSel = el.querySelector('[data-bmp-fms-h]');
    const wSel = el.querySelector('[data-bmp-fms-w]');
    if (!panel || !hSel || !wSel) return;
    const h = s.h || hSel.dataset.default, w = s.w || wSel.dataset.default;
    if (h && hSel.value !== h) hSel.value = h;
    if (w && wSel.value !== w) wSel.value = w;
    if (panel.hidden === s.open) panel.hidden = !s.open;
    if (el.hasAttribute('data-open') !== s.open) el.toggleAttribute('data-open', s.open);
    const btn = el.querySelector('[data-bmp-fms-open]');
    if (btn && btn.getAttribute('aria-expanded') !== String(s.open)) btn.setAttribute('aria-expanded', String(s.open));
    if (!s.open) return;

    const rec = recommend(+hSel.value, +wSel.value);
    const color = selectedColor(el);
    const avail = availableSizes(el, color);
    const pick = closest(rec, avail);
    setText(el.querySelectorAll('[data-bmp-fms-z]'), pick || rec);
    const why = el.querySelector('[data-bmp-fms-why]');
    const z = pick || rec;
    setText([why], `Fits a ${RANGE[z]}" chest · shirt is ${FLAT[z]}" across`);
    const alt = el.querySelector('[data-bmp-fms-alt]');
    let altText = '';
    if (!pick) altText = `${rec} isn't available${color ? ` in ${color}` : ''} right now.`;
    else if (pick !== rec) altText = `${rec} isn't available${color ? ` in ${color}` : ''}, so ${pick} is the closest fit.`;
    setText([alt], altText);
    if (alt.hidden !== !altText) alt.hidden = !altText;

    const sel = el.querySelector('[data-bmp-fms-select]');
    const checked = sizeInputs(el).find((i) => i.checked);
    const done = !!(pick && checked && up(checked.value) === pick);
    if (sel.hidden !== !pick) sel.hidden = !pick;
    if (sel.getAttribute('aria-pressed') !== String(done)) sel.setAttribute('aria-pressed', String(done));
    const label = done ? `✓ ${pick} selected` : `Select ${pick}`;
    if (sel.dataset.label !== label) { sel.dataset.label = label; sel.textContent = label; }
  }

  const all = () => document.querySelectorAll('[data-bmp-fms]');
  let queued = false;
  const renderAll = () => { if (queued) return; queued = true; requestAnimationFrame(() => { queued = false; all().forEach(render); }); };

  document.addEventListener('click', (e) => {
    const t = e.target instanceof Element ? e.target : null;
    const el = t && t.closest('[data-bmp-fms]');
    if (!el) return;
    const s = st(el);
    if (t.closest('[data-bmp-fms-open]')) { s.open = true; render(el); el.querySelector('[data-bmp-fms-h]')?.focus({ preventScroll: true }); return; }
    if (t.closest('[data-bmp-fms-close]')) { s.open = false; render(el); el.querySelector('[data-bmp-fms-open]')?.focus({ preventScroll: true }); return; }
    const selBtn = t.closest('[data-bmp-fms-select]');
    if (selBtn) {
      e.preventDefault();
      const z = selBtn.dataset.label && selBtn.dataset.label.replace(/^Select\s+/, '');
      if (!z || selBtn.getAttribute('aria-pressed') === 'true') return;
      const input = sizeInputs(el).find((i) => up(i.value) === up(z));
      const label = input && input.closest('label');
      if (label) label.click(); // same path as a real tap: Horizon change -> size gate -> morph
    }
  });

  document.addEventListener('change', (e) => {
    const t = e.target instanceof Element ? e.target : null;
    const el = t && t.closest('[data-bmp-fms]');
    if (el) {
      e.stopPropagation(); // never let height/weight changes reach theme listeners
      const s = st(el);
      if (t.matches('[data-bmp-fms-h]')) s.h = t.value;
      if (t.matches('[data-bmp-fms-w]')) s.w = t.value;
      render(el);
    } else {
      renderAll(); // a size/color change elsewhere in the buy box
    }
  });

  // Buy-box morphs replace or patch the snippet markup; re-apply state afterwards.
  new MutationObserver((records) => {
    for (const r of records) {
      const n = r.target;
      if (n instanceof Element && n.closest('[data-bmp-fms]') && r.type === 'attributes') continue;
      renderAll();
      return;
    }
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['checked', 'data-current-checked'] });

  window.__bmpFms = { state, renderAll };
  renderAll();
})();
// BMP-HOOK-END:find-my-size
